import React from "react"
import { animated } from "react-spring"
import logo from "./images/logo-edison.svg"
import Menu from '../components/Menu/Menu'
import frecciaOrange from './images/freccia-orange.svg'
import facebook from './images/credits/facebook.svg'
import twitter from './images/credits/twitter.svg'
import youtube from './images/credits/youtube.svg'
import linkedin from './images/credits/linkedin.svg'
import instagram from './images/credits/instagram.svg'
import videoIcon from './images/credits/video-credits.svg'
import frecciaIcon from './images/credits/freccia-credits.svg'
import { FacebookShareButton, TwitterShareButton, LinkedinShareButton } from "react-share";

const origin = typeof window !== "undefined" ? window.location.origin : ""
const shareUrl = 'https://stories.efficienzaenergetica.edison.it/fleet-audit'

const Credits = ({ backgroundColor, openPercent, color, innerRef, navigate }) => {
  return (
    <div ref={innerRef} style={{ background: backgroundColor, color: color }} className="h-100 grid-cols-6 xl:grid-cols-12">
      <div className='col-1'>
        {/* <Menu /> */}
      </div>
      <div className='col-3'>
        <div className='lg:mt-8 xl:mt-6 lg:font-18 xl:font-16 lg:line-height-24 xl:line-height-22'>Crediti</div>
        <div className='mt-5 lg:font-32 xl:font-30 font-family-acumin font-weight-500'>
          Le soluzioni <br />
          energetiche<br />
          di Edison
        </div>
        <div className='mt-2 lg:font-16 xl:font-14 lg:line-height-24 xl:line-height-22'>
          Per una mobilità sostenibile
        </div>
        <a
          href={'https://www.youtube.com/watch?v=Q28IO29ESqw&feature=youtu.be'}
          target='_blank'
          rel="noopener noreferrer"
          style={{ height: 96 }}
          className='link video-icon mt-5 d-flex align-items-center font-family-acumin font-weight-500 lg:font-18 xl:font-16 lg:line-height-24 xl-line-height-22'>
          Guarda il video
          <img className='ml-1' src={videoIcon}  alt='Video' />
        </a>
        <div className='lg:mt-5 xl:mt-4'>
          <img src={logo} alt='Edison' />
        </div>
        <div className='lg:mt-15 font-12 xl:mt-4'>
          <a className='link' rel="noopener noreferrer" href='https://www.efficienzaenergetica.edison.it/privacy-policy/' target='_blank'>Privacy</a>
          <a className='ml-3 link' rel="noopener noreferrer" href='https://www.efficienzaenergetica.edison.it/informativa-cookies/' target='_blank'>Informativa cookies</a>
        </div>
        <div className='lg:mt-15 font-12 xl:mt-3'>
        Reg. Imprese di Milano <br/>
        C.F. 06722600019 <br/>
        Partita IVA 08263330014 <br/>
        REA di Milano 1698754
        </div>
      </div>
      <div className='col-1'>

      </div>
      <div className='col-3'>
        <div className='lg:mt-16 xl:mt-14 font-weight-500 font-family-acumin lg:font-32 xl:font-30'>
          Fleet Audit<br />
          e servizi per<br />
          le aziende
        </div>
        <div className='mt-2 lg:font-16 xl:font-14 lg:line-height-24 xl:line-height-22'>
          La mobilità del futuro è già qui
        </div>
        <a
          href={'https://www.efficienzaenergetica.edison.it/offerta/o/mobilita-elettrica/'}
          target='_blank'
          rel="noopener noreferrer"
          style={{ height: 96 }}
          className='link freccia-icon-credits mt-5 d-flex align-items-center font-family-acumin font-weight-500 lg:font-18 xl:font-16 lg:line-height-24 xl-line-height-22'>
          Scopri di più
          <img className='ml-1' src={frecciaIcon}  alt='Video' />
        </a>
        <div className='lg:mt-5 xl:mt-4'>
          <div className='font-family-acumin font-weight-500 lg:font-18 xl:font-16 lg:line-height-24 xl-line-height-22'>Dove siamo</div>
          <div className='lg:font-16 xl:font-14 lg:line-height-20 xl:line-height-18 mt-1'>Edison Spa</div>
          <div className='lg:font-16 xl:font-14 lg:line-height-20 xl:line-height-18 mt-1'>
            Foro Buonaparte 31 <br />
            20121 Milano, Italia
          </div>
          <div className='lg:mt-8 font-12 xl:mt-4'>
            Copyright © Mar. 2020 Edison Spa <br />
            Capitale Soc. € 5.377.000.671,00 i.v. <br />
            Pec: gruppoedison@pec.edison.it
          </div>
        </div>
      </div>
      <div className='col-1'>

      </div>
      <div className='col-3'>
        <div onClick={() => navigate("/")} style={{ height: 96 }} className='cursor-pointer d-flex icon-bigger align-items-center lg:mt-16 xl:mt-14 font-weight-500 font-family-acumin lg:font-32 xl:font-30'>
          <span>Torna <br />
          all’inizio</span>
          <img className='ml-1' src={frecciaIcon} alt={'Torna all inizio'} style={{ transform: 'rotate(-90deg)'}} />
        </div>
        <div className='mt-4 font-family-acumin font-weight-500 lg:font-32 xl:font-30'>
          Share
        </div>
        <div className='mt-2'>
          <div className='d-flex social-link'>
            <img src={frecciaOrange} alt='Freccia orange' className="arrow-for-list"/>
            <div className='ml-1 lg:font-18 xl:font-16 lg:line-height-24 xl:line-height-22'>
              <LinkedinShareButton url={shareUrl}>Linkedin</LinkedinShareButton>
            </div>
          </div>
          <div className='mt-1 d-flex social-link'>
            <img src={frecciaOrange} alt='Freccia orange' className="arrow-for-list"/>
            <div className='ml-1 lg:font-18 xl:font-16 lg:line-height-24 xl:line-height-22'>
              <FacebookShareButton url={shareUrl}>Facebook</FacebookShareButton>
            </div>
          </div>
          <div className='mt-1 d-flex social-link'>
            <img src={frecciaOrange} alt='Freccia orange' className="arrow-for-list"/>
            <div className='ml-1 lg:font-18 xl:font-16 lg:line-height-24 xl:line-height-22'>
              <TwitterShareButton url={shareUrl}>Twitter</TwitterShareButton>
            </div>
          </div>
          <div className='mt-10 font-family-acumin lg:font-18 xl:font-16 lg:line-height-24 xl-line-height-22'>
            Contatti
          </div>
          <div className='mt-1 d-flex social-link'>
            <img src={frecciaOrange} alt='Freccia orange' className="arrow-for-list"/>
            <a rel="noopener noreferrer" target='_blank' href={'https://www.efficienzaenergetica.edison.it/contatti/'} className='ml-1 link lg:font-16 xl:font-14 lg:line-height-22 xl:line-height-20'>
              Scrivici un messaggio, <br />
              ti ricontatteremo noi
            </a>
          </div>
          <div style={{ width: 150 }} className='lg:mt-12 xl:mt-7 d-flex justify-content-between'>
            <a href='https://www.facebook.com/EdisonS.p.a/' rel="noopener noreferrer" target='_blank'><img src={facebook} alt={'Facebook'} /></a>
            <a href='https://twitter.com/EdisonNews?s=20' rel="noopener noreferrer" target='_blank'><img src={twitter} alt={'Twitter'} /></a>
            <a href='https://www.instagram.com/edison_onoff/' rel="noopener noreferrer" target='_blank'><img src={instagram} alt={'Instagram'} /></a>
            {/* <a href='https://www.youtube.com/channel/UCOzAKqdXJYVeuvv_kCxsXiA' rel="noopener noreferrer" target='_blank'><img src={youtube} alt={'Youtube'} /></a> */}
            <a href='https://www.linkedin.com/company/edison-spa/?originalSubdomain=it' rel="noopener noreferrer" target='_blank'><img src={linkedin} alt={'Linkedin'} /></a>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Credits
